/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { IdentificationIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import Player from '../VoiceMessage/Player';

const AudioValue = ({ file, onFetchAudioSource = () => {}, onWriteExamination = null }) => {
  const { t } = useTranslation('components', { keyPrefix: 'PamInquiry.AudioValue' });

  return (
    <div
      className="flex bg-blue-100 rounded items-center p-2 w-full first:ml-0"
      key={`FileMessage_File${file.id}`}
    >
      <Player
        src={() => onFetchAudioSource(file)}
        initialDuration={file.duration}
        caption={file.name.replace(/\.[^/.]+$/, '')}
        defer
      >
        {onWriteExamination && (
          <button
            onClick={() => onWriteExamination(file)}
            type="button"
            className="text-blue-500 hover:text-blue-700 bg-transparent hover:bg-slate-100 px-1 rounded-md text-sm flex flex-row items-center justify-center"
          >
            <IdentificationIcon className="h-6 w-6" />
            <span className="text-sm whitespace-nowrap ml-1">{t('writeExamination')}</span>
          </button>
        )}
      </Player>
    </div>
  );
};

AudioValue.propTypes = {
  file: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    duration: PropTypes.number,
  }).isRequired,
  onFetchAudioSource: PropTypes.func,
  onWriteExamination: PropTypes.func,
};

export default AudioValue;
